import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {pexios, toast, uploadImages} from '../../utils/functions';
import {history} from '../../utils/variables';
import Modal from '../../components/master/Modal';
import UserData from "../../components/expert/details/UserData";
import ThirdData from "../../components/expert/details/ThirdData";
import BodyData from "../../components/expert/details/BodyData";
import CarData from "../../components/expert/details/CarData";
import AccidentData from "../../components/expert/details/AccidentData";
import { useTranslation } from 'react-i18next';


export default function CulpritDetail() {

    const {id} = useSelector(store => store.routerData);
    const { t } = useTranslation();
    const [data, setData] = useState({
        attachments: [],
    });
    const [step, setStep] = useState(1);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        pexios('/api/v2/get_accident', 'post', {accident_id: id, type: 'culprit'})
            .then(res => {
                const accident = res.data.data;
                const {culprit = {}} = accident;
                const {car = {}, user = {}} = culprit;
                const {third = {}, body = {}} = car;
                delete user.attachments;
                delete user.avatar;
                delete car.third;
                delete car.body;
                delete culprit.car;
                delete culprit.user;
                delete accident.user;
                delete accident.culprit;
                const data = {...accident, ...culprit, ...car, ...user, third, body}
                setData(data);
            });
    }, [id]);


    function changeData(value, name, type) {
        setData(prevState => ({
            ...prevState,
            ...(type
                    ? {
                        [type]: {
                            ...prevState[type],
                            [name]: value
                        }
                    }
                    : {[name]: value}
            )
        }));
    }

    function finishUpload(image, name, done) {
        uploadImages({
            id,
            type: 'accident',
            name,
            image,
            done,
            callback: (data) => {
                setData(prevState => ({
                    ...prevState,
                    attachments: [
                        ...prevState.attachments,
                        data,
                    ],
                }));
            },
        });
    }

    function changeStep(step) {
        setStep(step);
        const element = document.getElementById('content');
        setTimeout(() => element.scrollIntoView());
    }

    function submit() {
        setLoader(true);
        pexios('/api/update_culprit', 'post', {...data})
            .then(() => {
                if (data.insurance_type === 'body')
                    history.push('/expert-images');
                else
                    history.push('/losses-detail');
            });
    }

    return (
        <div className='content details mt20'>
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <p>{t('Loading')}</p>
                    <i className='fas fa-spinner fa-spin'/>
                </div>
            </Modal>
            <div id='content' />
            {
                step === 1 &&
                <UserData
                    data={data}
                    changeData={changeData}
                    uploadImage={finishUpload}
                    changeStep={changeStep}
                />
            }
            {
                step === 2 &&
                <ThirdData
                    data={data}
                    changeData={changeData}
                    uploadImage={finishUpload}
                    changeStep={changeStep}
                />
            }
            {
                step === 3 &&
                    <BodyData
                        data={data}
                        changeData={changeData}
                        uploadImage={finishUpload}
                        changeStep={changeStep}
                    />
            }
            {
                step === 4 &&
                    <CarData
                        data={data}
                        changeData={changeData}
                        uploadImage={finishUpload}
                        changeStep={changeStep}
                    />
            }
            {
                step === 5 &&
                    <AccidentData
                        data={data}
                        changeData={changeData}
                        uploadImage={finishUpload}
                        changeStep={changeStep}
                        submit={submit}
                    />
            }
        </div>
    );

}
